import React from 'react';
import Helmet from '../../common/helmet';

const AdminCouponManagement = props => {
  return (
    <>
      <Helmet title="Expert Management" />
      <p>Coupons management</p>
    </>
  );
};

export default AdminCouponManagement;
